import { ajax } from 'jquery';

export default (method, url, data) => {
  return new Promise((resolve, reject) => {
    ajax({
      url,
      method,
      data,
      dataType: 'json',
      contentType: 'application/json',
    })
      .done((results) => resolve(results))
      .catch((err) => reject(err));
  });
};
